import { IComponentOptions, IController } from 'angular';
import { $Event } from '../../helpers';
import range from 'lodash-es/range';
import './gmc-pagination.component.scss';

export class GmcPaginationController implements IController {
  static $inject = [];
  pageSelected: ($event) => void;
  pages: number[];
  currentPage: number;
  step: number;
  isMobile: boolean = false;
  private _pagesCount: number;

  constructor() {
  }

  $onInit() {
    this.isMobile = window.innerWidth < 800 ? true : false;
    this.setStep();
  }

  setStep() {
    this.step = this.isMobile ? 4 : 7;
  }

  set pagesCount(count: number) {
    this._pagesCount = count;
    this.calculatePages();
  }

  get pagesCount(): number {
    return this._pagesCount;
  }

  selectPage(page: number) {
    if (page < 1 || page > this._pagesCount) {
      return;
    }
    this.currentPage = page;
    this.calculatePages();
    this.pageSelected(new $Event({ page }));
  }

  private calculatePages() {
    const middleware = (this.step - this.step % 2) / 2;
    const startPage = this.currentPage > middleware ? this.currentPage - middleware + 1 : 1;
    let endPage;
    if (this.currentPage < (this.pagesCount - middleware)) {
      endPage = this.currentPage > middleware ? this.currentPage + middleware : this.step;
    } else {
      endPage = this.pagesCount + 1;
    }
    this.pages = range(startPage, endPage);
  }

}

export const GmcPaginationComponent: IComponentOptions = {
  controller: GmcPaginationController,
  template: require('./gmc-pagination.component.html'),
  bindings: {
    pagesCount: '<',
    currentPage: '<',
    step: '<?',
    pageSelected: '&'
  }
};



// WEBPACK FOOTER //
// ./app/ui/gmc-pagination/gmc-pagination.component.ts